import { Reducer } from 'redux';

import {
    AuditWorkpapersActions,
    KnownAction,
} from './Actions';

import { AuditWorkpaperSummary } from '../../Models/Api/strongbox.financialportal';

export interface IAuditWorkpapersState {
    // The set of audit workpapers retrieved from the back end.
    workpapers: AuditWorkpaperSummary[];
    // True while a load is in flight.
    loading: boolean;
    // True once a load has completed successfully (used to only load the first time).
    loaded: boolean;
    // Set if the most recent load failed.
    error?: string;
    // How many years back the audit year may be selected (bounds the audit-year date picker). Held in
    // state so it can be made server-/config-driven later; for now it defaults to 8.
    maxAuditYearsBack: number;
}

const defaultState: IAuditWorkpapersState = {
    workpapers: [],
    loading: false,
    loaded: false,
    maxAuditYearsBack: 8,
}

export const reducer: Reducer<IAuditWorkpapersState, KnownAction> = (state: IAuditWorkpapersState | undefined, action: KnownAction): IAuditWorkpapersState => {
    switch (action.type) {
        case AuditWorkpapersActions.LoadStart: {
            return {
                ...(state ? state : defaultState),
                loading: true,
                error: undefined,
            }
        }
        case AuditWorkpapersActions.LoadComplete: {
            return {
                ...(state ? state : defaultState),
                loading: false,
                loaded: true,
                workpapers: action.workpapers,
                error: undefined,
            }
        }
        case AuditWorkpapersActions.LoadError: {
            return {
                ...(state ? state : defaultState),
                loading: false,
                loaded: false,
                error: action.error,
            }
        }
    }

    return state ? state : defaultState;
}
